import update from "immutability-helper";
import _ from "underscore";
import Attrs from "assets/data/AttributeData";

export const SET_SETUP_ATTRS = "setupAttr/SET_SETUP_ATTRS";
export const SET_SETUP_ATTR_LOCALE = "setupAttr/SET_SETUP_ATTR_LOCALE";
export const UPDATE_SETUP_ATTR_ORDER = "setupAttr/UPDATE_SETUP_ATTR_ORDER";
export const ADD_SETUP_ATTR_ITEM = "setupAttr/ADD_SETUP_ATTR_ITEM";
export const REMOVE_SETUP_ATTR_ITEM = "setupAttr/REMOVE_SETUP_ATTR_ITEM";

export const OPEN_EDIT_ATTR_MODAL = "setupAttr/OPEN_EDIT_ATTR_MODAL";
export const CLOSE_EDIT_ATTR_MODAL = "setupAttr/CLOSE_EDIT_ATTR_MODAL";
export const REGIST_EDIT_ATTR_MODAL = "setupAttr/REGIST_EDIT_ATTR_MODAL";

export const UPDATE_SETUP_ATTR_ITEM_ORDER =
  "setupAttr/UPDATE_SETUP_ATTR_ITEM_ORDER";
export const UPDATE_EDIT_ATTR_NAME = "setupAttr/UPDATE_EDIT_ATTR_NAME";
export const UPDATE_SETUP_ATTR_ITEM = "setupAttr/UPDATE_SETUP_ATTR_ITEM";
export const REMOVE_EDIT_ATTR_ITEM = "setupAttr/REMOVE_EDIT_ATTR_ITEM";
export const CHANGE_EDIT_ATTR_ITEM = "setupAttr/CHANGE_EDIT_ATTR_ITEM";

export const DISCARD_EDIT_ATTR = "setupAttr/DISCARD_EDIT_ATTR";
export const SET_SETUP_ATTR_ERRORS = "setupAttr/SET_SETUP_ATTR_ERRORS";

// SetupAttr Actions
export const setAttrs = res => ({
  type: SET_SETUP_ATTRS,
  res
});
export const setSetupAttrLocale = localeNo => ({
  type: SET_SETUP_ATTR_LOCALE,
  localeNo
});
export const updateSetupAttrOrder = (attr, index, atIndex) => ({
  type: UPDATE_SETUP_ATTR_ORDER,
  attr,
  index,
  atIndex
});
export const removeSetupAttrItem = index => ({
  type: REMOVE_SETUP_ATTR_ITEM,
  index
});

export const openEditAttrModal = attrId => ({
  type: OPEN_EDIT_ATTR_MODAL,
  attrId
});
export const registEditAttrModal = attrId => ({
  type: REGIST_EDIT_ATTR_MODAL,
  attrId
});
export const closeEditAttrModal = () => ({
  type: CLOSE_EDIT_ATTR_MODAL
});
export const updateEditAttrName = attrName => ({
  type: UPDATE_EDIT_ATTR_NAME,
  attrName
});
export const updateAttrItem = (name, value) => ({
  type: UPDATE_SETUP_ATTR_ITEM,
  name,
  value
});
export const updateSetupAttrAttrItemOrder = (attrItem, index, atIndex) => ({
  type: UPDATE_SETUP_ATTR_ITEM_ORDER,
  attrItem,
  index,
  atIndex
});
export const addSetupAttrAttrItem = () => ({
  type: ADD_SETUP_ATTR_ITEM
});
export const removeSetupAttrAttrItem = index => ({
  type: REMOVE_EDIT_ATTR_ITEM,
  index
});
export const changeSetupAttrAttrItem = (index, value) => ({
  type: CHANGE_EDIT_ATTR_ITEM,
  index,
  value
});

export const discardEditAttr = attrId => ({
  type: DISCARD_EDIT_ATTR,
  attrId
});
export const setErrors = errors => ({
  type: SET_SETUP_ATTR_ERRORS,
  errors
});

const initialState = {
  localeNo: "",
  answerMethods: {},
  attrs: [],
  locales: [],
  editAttrModal: {
    open: false,
    attrId: "",
    attr: {}
  },
  lockVersion: "",
  errors: []
};

// Reducer
const setupAttr = (state = initialState, action) => {
  switch (action.type) {
    /* SetupAttr */
    case SET_SETUP_ATTRS: {
      const newState = state;
      const { res } = action;

      const locales = res.locales.map(locale => {
        newState.answerMethods[locale.locale.key] = locale.answerDescription;
        return locale.locale.key;
      });

      const attrs = res.attrs.length
        ? res.attrs
        : JSON.parse(JSON.stringify(Attrs()));
      newState.localeNo = res.locales[0].locale.key;
      newState.attrs = attrs;
      newState.locales = locales;
      newState.lockVersion = res.customer.lockVersion;

      return { ...newState };
    }
    case SET_SETUP_ATTR_LOCALE: {
      const newState = state;
      const { localeNo } = action;
      newState.localeNo = localeNo;
      return { ...newState };
    }
    case UPDATE_SETUP_ATTR_ITEM: {
      const { name, value } = action;
      const newState = update(state, {
        [name]: {
          [state.localeNo]: {
            $set: value
          }
        }
      });
      return { ...newState };
    }
    case UPDATE_SETUP_ATTR_ORDER: {
      const { attr, index, atIndex } = action;
      const newState = update(state, {
        attrs: {
          $splice: [[index, 1], [atIndex, 0, attr]]
        }
      });
      return { ...newState };
    }
    case REMOVE_SETUP_ATTR_ITEM: {
      const { index } = action;

      const newState = update(state, {
        attrs: {
          $splice: [[index, 1]]
        }
      });
      return { ...newState };
    }

    case OPEN_EDIT_ATTR_MODAL: {
      const { attrId } = action;
      let target = _.find(state.attrs, attr => {
        return attr.id === attrId;
      });
      if (!target) {
        target = {
          locale: {}
        };
        target.locale = {};

        state.locales.forEach(locale => {
          target.locale[locale] = {
            id: "",
            attrName: "",
            attrItems: []
          };
        });
      }
      const editAttrModal = {
        open: true,
        attrId: attrId || "",
        attr: JSON.parse(JSON.stringify(target))
      };
      return { ...state, editAttrModal };
    }
    case REGIST_EDIT_ATTR_MODAL: {
      const { attrId } = action;

      const target = _.find(state.attrs, attr => {
        return attr.id === attrId;
      });
      if (target) {
        const index = state.attrs.indexOf(target);
        const newState = update(state, {
          attrs: {
            [index]: { $set: state.editAttrModal.attr }
          }
        });
        return { ...newState };
      }

      const newItems = _.filter(state.attrs, attr => {
        return String(attr.id).indexOf("new") > -1;
      });
      const maxId = _.max(newItems, item => {
        return String(item.id).replace("new-", "");
      });
      let id = 1;
      if (maxId !== -Infinity) {
        id = parseInt(String(maxId.id).replace("new-", ""), 10) + 1;
      }
      state.editAttrModal.attr.id = `new-${id}`;
      state.editAttrModal.attr.presetFlg = false;
      state.editAttrModal.attr.attrNo = state.attrs.length;

      const newState = update(state, {
        attrs: {
          $push: [state.editAttrModal.attr]
        }
      });
      return { ...newState };
    }
    case CLOSE_EDIT_ATTR_MODAL: {
      const newState = update(state, {
        editAttrModal: {
          $merge: { open: false }
        }
      });
      return { ...newState };
    }
    case DISCARD_EDIT_ATTR: {
      const { attrId } = action;

      // 戻す対象の属性
      const targetAttr = _.find(state.attrs, attr => {
        return attr.id === attrId;
      });
      // デフォルト設定
      const defaultAttr = _.find(JSON.parse(JSON.stringify(Attrs())), attr => {
        return attr.attrNo === targetAttr.attrNo;
      });
      // 対象属性のIDを移植（別属性として扱われないように）
      defaultAttr.id = attrId;
      const editAttrModal = {
        open: true,
        attrId,
        attr: defaultAttr
      };
      return { ...state, editAttrModal };
    }
    case UPDATE_EDIT_ATTR_NAME: {
      const { attrName } = action;
      const newState = update(state, {
        editAttrModal: {
          attr: {
            locale: {
              [state.localeNo]: {
                attrName: { $set: attrName }
              }
            }
          }
        }
      });
      return { ...newState };
    }
    case UPDATE_SETUP_ATTR_ITEM_ORDER: {
      const { index, atIndex } = action;
      let newState = state;

      state.locales.forEach(locale => {
        const item =
          newState.editAttrModal.attr.locale[locale].attrItems[index];
        newState = update(newState, {
          editAttrModal: {
            attr: {
              locale: {
                [locale]: {
                  attrItems: {
                    $splice: [[index, 1], [atIndex, 0, item]]
                  }
                }
              }
            }
          }
        });
      });
      return { ...newState };
    }
    case ADD_SETUP_ATTR_ITEM: {
      let newState = state;
      const newItems = _.filter(
        state.editAttrModal.attr.locale[state.localeNo].attrItems,
        attrItem => {
          return String(attrItem.id).indexOf("new") > -1;
        }
      );
      const maxId = _.max(newItems, item => {
        return parseInt(String(item.id).replace("new-", ""), 10);
      });

      let id = 1;
      if (maxId !== -Infinity) {
        id = parseInt(String(maxId.id).replace("new-", ""), 10) + 1;
      }
      const attrItem = {
        id: `new-${id}`,
        itemName: ""
      };
      state.locales.forEach(locale => {
        newState = update(newState, {
          editAttrModal: {
            attr: {
              locale: {
                [locale]: {
                  attrItems: {
                    $push: [attrItem]
                  }
                }
              }
            }
          }
        });
      });

      return { ...newState };
    }
    case REMOVE_EDIT_ATTR_ITEM: {
      let newState = state;
      const { index } = action;
      state.locales.forEach(locale => {
        newState = update(newState, {
          editAttrModal: {
            attr: {
              locale: {
                [locale]: {
                  attrItems: {
                    $splice: [[index, 1]]
                  }
                }
              }
            }
          }
        });
      });
      return { ...newState };
    }
    case CHANGE_EDIT_ATTR_ITEM: {
      const { index, value } = action;
      const newState = update(state, {
        editAttrModal: {
          attr: {
            locale: {
              [state.localeNo]: {
                attrItems: {
                  [index]: { itemName: { $set: value } }
                }
              }
            }
          }
        }
      });

      return { ...newState };
    }
    default:
      return state;
  }
};

export default setupAttr;



// WEBPACK FOOTER //
// ./src/redux/modules/setupAttr.js